import styles from "./index.module.css";
import FakeButton from "../../../Components/FormComponents/FakeButton";
import background from "./background.png";
import heading from "./Heading.png";

export default function LandingBlock({ setPopup }) {
  return (
    <div id={"about"} className={styles.container}>
      <div
        className={styles.content}
        style={{ backgroundImage: `url(${background})` }}
      >
        <div className={styles.textContainer}>
          <img className={styles.heading} src={heading} alt="Win Winter" />

          <p className={styles.description}>
            Підніми свій рівень інглішу в 3 рази швидше від темпу звичайної
            програми
          </p>

          <div className={styles.actionBar}>
            <div className={styles.badge}>
              <span>Зимовий інтенсив</span>
              <strong>Грудень - Лютий</strong>
            </div>
            <FakeButton className={styles.button} onClick={setPopup}>
              Хочу взяти участь!
            </FakeButton>
          </div>
        </div>
      </div>
    </div>
  );
}
